export default "__VITE_ASSET__0e88f1ce__"